import React from 'react';
import cn from '../utils/cn';

// Merges adjacent controls into one visual field (e.g. search input +
// button, input + select). Children keep their own APIs; outer corners
// stay rounded, inner corners are squared off and borders collapsed.
// The `>*>input` selectors reach the input inside KoobInputText's icon
// wrapper. Match child sizes yourself (e.g. input md h-10 + button lg h-10).
const KoobInputGroup = React.forwardRef<
  HTMLDivElement,
  Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> & {
    // not part of the API (see packages/ui/README.md); stripped below
    className?: never;
  }
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex w-full items-stretch',
      '[&>*:not(:first-child)]:rounded-l-none [&>*:not(:first-child)>input]:rounded-l-none',
      '[&>*:not(:last-child)]:rounded-r-none [&>*:not(:last-child)>input]:rounded-r-none',
      '[&>*:not(:first-child)]:-ml-px',
    )}
    {...props}
  />
));

KoobInputGroup.displayName = 'KoobInputGroup';

export default KoobInputGroup;
